var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("sidebar-widget", {
    attrs: {
      title: _vm.$gettext("Neueste Einträge"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "div",
              {
                staticClass: "cw-filter-widget",
              },
              [
                _c(
                  "form",
                  {
                    staticClass: "default",
                    on: {
                      submit: function submit($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.createdFilter,
                            expression: "createdFilter",
                          },
                        ],
                        attrs: {
                          "aria-label": _vm.$gettext(
                            "Filter: Neueste Einträge"
                          ),
                        },
                        on: {
                          change: function change($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.createdFilter = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: {
                              value: "all",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$gettext("unbeschränkt")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: {
                              value: "oneDay",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$gettext("einen Tag alt")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "option",
                          {
                            attrs: {
                              value: "oneWeek",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$gettext("eine Woche alt")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }